export default "__VITE_ASSET__1b89efeb__"